import { render, staticRenderFns } from "./PickingTableComponent.vue?vue&type=template&id=0841510e"
import script from "./PickingTableComponent.vue?vue&type=script&lang=js"
export * from "./PickingTableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports